import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {Comment} from '../models/comment.model';

@Injectable({
    providedIn: 'root'
})
export class CommentService {

    private API_URL= environment.API_URL;
    private MODEL_URL = 'comments';

    constructor(private http: HttpClient) { }

    getComments(dossierId: number): Observable<Comment[]> {
        return this.http.get<Comment[]>(this.API_URL + 'dossiers-interventions/' + dossierId + '/' + this.MODEL_URL);
    }

    saveComment(comment: Comment): Observable<Comment> {
        return this.http.post<Comment>(this.API_URL + 'dossiers-interventions/' + comment.dossier_intervention_id + '/' + this.MODEL_URL, comment);

    }
}
